import { LocationQuery } from 'vue-router';
import { CorrectionService } from './correction.service';

const service = new CorrectionService();

const state = {};

const mutations = {};

const actions = {
   async getCorrections(context: any, payload: { contractId: number; query?: LocationQuery }) {
      return await service.getCorrections(payload.contractId, payload.query);
   },
   async addCorrection(context: any, payload: { contractId: number; body: any }) {
      return await service.postCorrection(payload.contractId, payload.body);
   },
   async changeCorrection(context: any, payload: { contractId: number; correctionId: number; body: any }) {
      return await service.putCorrection(payload.contractId, payload.correctionId, payload.body);
   },
   async removeCorrection(context: any, payload: { contractId: number; correctionId: number }) {
      return await service.deleteCorrection(payload.contractId, payload.correctionId);
   },
};

export default {
   namespaced: true,
   state,
   mutations,
   actions,
};
